import { Component, HostListener, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { DomService } from '../../services/dom.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [ButtonModule, CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  showMobileMenu = false;
  isMobile = false;
  private domService = inject(DomService);
  private router = inject(Router);

  ngOnInit() {
    this.getWindowSize()
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.getWindowSize();
  }
  getWindowSize() {
    if (this.domService.getWindowELm()) {
      this.isMobile = this.domService.getWindowELm().innerWidth < 800;
    }
  }
  navigateToMonCompte() {
    this.router.navigate(['/login']);
  }
} 
